import { useEffect, useState } from 'react';
import React from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import { ExhibitionList } from '../../features/exhibition/ExhibitionRequestSlice'
import Loading from '../../Loading';
import Header from './Header';
import Broadcast from './Broadcast';
import { ToastContainer, toast } from 'react-toastify';
import { Calendar } from "react-multi-date-picker";
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import gregorian from "react-date-object/calendars/gregorian"
import persian_fa from "react-date-object/locales/persian_fa"
import gregorian_en from "react-date-object/locales/gregorian_en"
import persian_en from "react-date-object/locales/persian_en"
import Button from '../form/Button';
import Input from '../form/Input';
import DataTable, { ExpanderComponentProps } from 'react-data-table-component';
import axios from 'axios';
import { host } from '../../function/api'
import * as Icon from 'react-feather';
import $ from 'jquery'
import { saveAs } from 'file-saver';
import * as moment from 'jalali-moment';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css' 
import '../../assets/js/jhxlsx'
import * as XLSX from 'xlsx';





function RequestExhibitions() {
    const columns = [
        {
            name: '#',
            sortable: true,
            cell: row => <div className='rahpardaznet-border'>{row.id} </div>,

        },
        {

            name: 'شماره سند',
            sortable: true,
            cell: row => <div className='rahpardaznet-border'>{row.mt_sanadno}</div>
        },
        {
            name: 'شماره پلاک',
            sortable: true,
            cell: row => row.mt_pelakserial == "" ? (<span></span>) : (
                <div className="rk-pelak-back"><span>{row.mt_pelakserial}</span><span>{row.mt_pelakno}</span></div>),
        },
        {
            name: 'شماره بدنه',
            sortable: true,
            cell: row => <div className="rahpardaznet-border font-en">{row.mt_bodyno}</div>
        },
        {
            name: 'شماره موتور',
            sortable: true,
            cell: row => <div className="rahpardaznet-border font-en">{row.mt_motorno}</div>
        },
        {
            name: 'نام نمایشگاه',
            sortable: true,
            cell: row => <div className="rahpardaznet-border">{row.exhibition_name}</div>
        },
        {
            name: 'نام مالک',
            sortable: true,
            cell: row => <div className="rahpardaznet-border">{row.buyer_name}</div>
        },
        {
            name: 'تاریخ ایجاد',
            sortable: true,
            cell: row => <div className="rahpardaznet-border">{moment(row.created_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}</div>
        },
        {
            name: 'عملیات',
            cell: row => <div className='rahpardaznet-table-btn'>
                <button type="button" id={row.id}
                    onClick={(e) => documentStatusUpdateHandler(row.id)} className='rahpardaznet-icon-table'><i
                        className="fa-solid fa-sticky-note fa-fw"></i> </button>

                <button type="button"
                    onClick={(e) => requestDeleteConfirm(row.id)} className='rahpardaznet-icon-table'><i
                        className="fa-solid fa-trash fa-fw"></i> </button>
            </div>
        },


    ];

    const dispatch = useDispatch()
    const [status, setStatus] = useState(true)
    const token = localStorage.getItem('token')
    const date = new DateObject({ calendar: persian, locale: persian_fa })
    const [RahpardaznetMobile, setًRahpardaznetMobile] = useState('');
    const [RahpardaznetCode, setRahpardaznetCode] = useState('');
    const [RahpardaznetHash, setRahpardaznetHash] = useState('');
    const [RahpardaznetValidationStatus, setRahpardaznetValidationStatus] = useState('');
    const [BtnSms, setBtnSms] = useState('');
    const [RahpardaznetStatus, setRahpardaznetStatus] = useState('');
    const [RahpardaznetId, setRahpardaznetId] = useState('');
    const [RahpardaznetFilterExhibitionName, setRahpardaznetFilterExhibitionName] = useState('');
    const [RahpardaznetFilterType, setRahpardaznetFilterType] = useState('1');
    const [start_date, setStart_date] = useState({})
    const [end_date, setEnd_date] = useState({})
    const [RahpardaznetMessage, setRahpardaznetMessage] = useState('')
    const [RahpardaznetRequestID, setRahpardaznetRequestID] = useState('')
    const [RahpardaznetStatusID, setRahpardaznetStatusID] = useState('')
    const [RahpardaznetDetailsData, setRahpardaznetDetailsData] = useState({})
    const [RahpardaznetDetailsFiles, setRahpardaznetDetailsFiles] = useState({})
    const [fake_date, setFake_date] = useState({})
  
    const {
        exhibitions,
        loading,
        message
    } = useSelector(state => state.ExhibitionRequest)
  
    const [number, setNumber] = useState()
    const [numberType, setNumberType] = useState()
    const [RahpardaznetLoading, setRahpardaznetLoading] = useState()
    const [RahpardaznetRandomString, setRahpardaznetRandomString] = useState()
    const ExpandedComponent = ({ data }) => (
        <>
            <div className='row text-end p-2'>
                <div className='col-12'>
                    <div className='rahpardaznet-updated-at'>
                        <label>تاریخ بروزرسانی: </label>
                        <span>{moment(data.updated_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}</span>
                    </div>
                </div>
                <div className='col-12 col-md-6'>
                    <div className='rahpardaznet-details-request-item'>
                        <label>نام: </label>
                        <span>{data.customer_data.name}</span>
                    </div>
                    <div className='rahpardaznet-details-request-item'>
                        <label>نام خانوادگی: </label>
                        <span>{data.customer_data.family}</span>
                    </div>
                    <div className='rahpardaznet-details-request-item'>
                        <label>نام پدر: </label>
                        <span>{data.customer_data.father_name}</span>
                    </div>
                    <div className='rahpardaznet-details-request-item'>
                        <label>محل ثبت تولد: </label>
                        <span>{data.customer_data.birthplace}</span>
                    </div>
                    <div className='rahpardaznet-details-request-item'>
                        <label>آدرس محل سکونت: </label>
                        <span>{data.customer_data.address}</span>
                    </div>
                    <div className='rahpardaznet-details-request-item'>
                        <label>شماره شناسنامه / ملی: </label>
                        <span>{data.customer_data.nationalCode}</span>
                    </div>

                </div>
                <div className='col-12 col-md-6'>

                    <div className='rahpardaznet-details-request-item'>
                        <label>کد پستی: </label>
                        <span>{data.customer_data.postalcode}</span>
                    </div>
                    <div className='rahpardaznet-details-request-item'>
                        <label>تاریخ ثبت/تولد: </label>
                        <span>{data.customer_data.birthdaye}</span>
                    </div>
                    <div className='rahpardaznet-details-request-item'>
                        <label>شماره ثبت/شناسنامه: </label>
                        <span>{data.customer_data.idcard}</span>
                    </div>
                    <div className='rahpardaznet-details-request-item'>
                        <label>ثبت / محل صدور: </label>
                        <span>{data.customer_data.placeofissue}</span>
                    </div>
                    <div className='rahpardaznet-details-request-item'>
                        <label>تلفن ثابت: </label>
                        <span>{data.customer_data.phone}</span>
                    </div>
                    <div className='rahpardaznet-details-request-item'>
                        <label>شماره موبایل: </label>
                        <span>{data.customer_data.mobile}</span>
                    </div>
                </div>
            </div>
        </>
    )

    const rahpardazneRestForm = (event) => {
        event.preventDefault()
        setRahpardaznetFilterExhibitionName('0');
        setRahpardaznetFilterType('1');
        setStart_date({ date: " " });
        setEnd_date({ date: " " });

        getUserList();
        toast.success("فرم با موفقیت پاکسازی شد.", {
            position: "top-center",
            autoClose: 1200,
        })

    }

    const rahpardaznetFilterRequest = (e) => {
        e.preventDefault();
        setPinCode("");
        getUserList();

    }

    var Jhxlsx = {
        config: {
            fileName: "report",
            extension: ".xlsx",
            sheetName: "Sheet",
            fileFullName: "report.xlsx",
            header: true,
            createEmptyRow: true,
            maxCellWidth: 20
        },
        worksheetObj: {},
        rowCount: 0,
        wsColswidth: [],
        merges: [],
        worksheet: {},
        range: {},
        init: function (options) {
            this.reset();
            if (options) {
                for (var key in this.config) {
                    if (options.hasOwnProperty(key)) {
                        this.config[key] = options[key];
                    }
                }
            }
            this.config['fileFullName'] = this.config.fileName + this.config.extension;
        },
        reset: function () {
            this.range = {s: {c: 10000000, r: 10000000}, e: {c: 0, r: 0}};
            this.worksheetObj = {};
            this.rowCount = 0;
            this.wsColswidth = [];
            this.merges = [];
            this.worksheet = {};
        },
        parse2Int0: function (num) {
            num = parseInt(num);
            num = Number.isNaN(num) ? 0 : num;
            return num;
        },
        cellWidth: function (cellText, pos) {
            var max = (cellText && cellText.length * 1.3);
            if (this.wsColswidth[pos]) {
                if (max > this.wsColswidth[pos].wch) {
                    this.wsColswidth[pos] = {wch: max};
                }
            } else {
                this.wsColswidth[pos] = {wch: max};
            }
        },
        cellWidthValidate: function () {
            for (var i in this.wsColswidth) {
                if (this.wsColswidth[i].wch > this.config.maxCellWidth) {
                    this.wsColswidth[i].wch = this.config.maxCellWidth;
                }
            }
        },
        datenum: function (v, date1904) {
            if (date1904)
                v += 1462;
            var epoch = Date.parse(v);
            return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
        },
        setCellDataType: function (cell) {
            if (typeof cell.v === 'number') {
                cell.t = 'n';
            } else if (typeof cell.v === 'boolean') {
                cell.t = 'b';
            } else if (cell.v instanceof Date) {
                cell.t = 'n';
                cell.z = XLSX.SSF._table[14];
                cell.v = this.datenum(cell.v);
            } else {
                cell.t = 's';
            }
        },
        jhAddRow: function (rowObj) {
            for (var c in rowObj) {
                c = this.parse2Int0(c);
                var cellObj = rowObj[c];
                if (this.range.s.r > this.rowCount)
                    this.range.s.r = this.rowCount;
                if (this.range.s.c > c)
                    this.range.s.c = c;
                if (this.range.e.r < this.rowCount)
                    this.range.e.r = this.rowCount;
                if (this.range.e.c < c)
                    this.range.e.c = c;
    
                var cellText = null;
                if (cellObj.hasOwnProperty('text')) {
                    cellText = cellObj.text;
                }
                var cell = {v: cellText};
    
                var calColWidth = true;
                if (cellObj.hasOwnProperty('merge')) {
                    var mergeObj = cellObj.merge;
                    calColWidth = false;
                    //var colStartEnd = cellObj.merge.split('-');
                    var ec = c;
                    var er = this.rowCount;
                    if (mergeObj.hasOwnProperty('c')) {
                        ec = (c + parseInt(mergeObj.c));
                    }
                    if (mergeObj.hasOwnProperty('r')) {
                        er = (this.rowCount + parseInt(mergeObj.r));
                    }
    
                    this.merges.push({s: {r: this.rowCount, c: c}, e: {r: er, c: ec}});
                    //this.merges.push({s: {r: this.rowCount, c: c}, e: {r: (this.rowCount + 1), c: (c + 2)}});
                }
                if (calColWidth) {
                    this.cellWidth(cell.v, c);
                }
                if (cell.v === null)
                    continue;
                var cell_ref = XLSX.utils.encode_cell({c: c, r: this.rowCount});
                this.setCellDataType(cell);
    
                if (cellObj.hasOwnProperty('style')) {
                    cell.s = cellObj.style;
                }
    
                this.worksheet[cell_ref] = cell;
            }
            this.rowCount++;
        },
        createWorkSheet: function () {
            for (var i in this.worksheetObj.data) {
                this.jhAddRow(this.worksheetObj.data[i]);
            }
            this.cellWidthValidate();
            //console.log(this.merges);
            //this.worksheet['!merges'] = [{s: {r: 0, c: 0}, e: {r: 0, c: 4}},{s: {r: 5, c: 0}, e: {r: 6, c: 3}}];//this.merges;
            this.worksheet['!merges'] = this.merges;
            this.worksheet['!cols'] = this.wsColswidth;
            if (this.range.s.c < 10000000)
                this.worksheet['!ref'] = XLSX.utils.encode_range(this.range);
            return this.worksheet;
        },
        s2ab: function (s) {
            var buf = new ArrayBuffer(s.length);
            var view = new Uint8Array(buf);
            for (var i = 0; i != s.length; ++i)
                view[i] = s.charCodeAt(i) & 0xFF;
            return buf;
        },
        getBlob: function (workbookObj, options) {
            this.init(options);
            var workbook = new Workbook();
            /* add worksheet to workbook */
            for (var i in workbookObj) {
                this.reset();
                this.worksheetObj = workbookObj[i];
                var sheetName = this.config.sheetName + i;
                if (this.worksheetObj.hasOwnProperty('sheetName')) {
                    sheetName = this.worksheetObj.sheetName;
                }
                this.createWorkSheet();
                workbook.SheetNames.push(sheetName);
                workbook.Sheets[sheetName] = this.worksheet;
            }
            var wbout = XLSX.write(workbook, {bookType: 'xlsx', bookSST: true, type: 'binary'});
            var blobData = new Blob([this.s2ab(wbout)], {type: "application/octet-stream"});
            return blobData;
        },
        export: function (workbookObj, options) {
            saveAs(this.getBlob(workbookObj, options), this.config.fileFullName);
        },
    }
    
    function Workbook() {
        if (!(this instanceof Workbook))
            return new Workbook();
        this.SheetNames = [];
        this.Sheets = {};
    }

    const rahpardaznetExportExcel = async (event) => {
        event.preventDefault()
        setRahpardaznetLoading('1');
        const data = {
            'exhibition': RahpardaznetFilterExhibitionName,
            'start_date': start_date,
            'end_date': end_date,

        }
        try {
             var count = 0;
            const response = await axios({
                method: 'POST',
                url: `${host}requestsExhibitionExportExcel`,
                data: data,
                headers: {
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            if(response.data.data === undefined || response.data.data.length == 0){
                alert('درخواستی در این روز ثبت نشده است.');
                 
            }else{
                $.each(response.data.data, function( index, value ) {
                    setTimeout(function(){
                        Jhxlsx.export(value.tableData, value.options);
                    }, count * 1000)
                    
                    console.log(count);
                    count++;
                   
                });
            }
            setRahpardaznetLoading(' ');
        } catch (error) {
            setRahpardaznetLoading(' ');
            console.log(error);
            toast.error('خروجی با موفقیت ایجاد نشد.', {
                position: "top-center",
                autoClose: 1200,
            })
            // if(typeof (error.response) == 'object'){
            //     const listError = error.response.data.error;
            //     // console.log(listError);

            //     $.each(listError, function (index, value) {
            //         // error+index = value[0];
            //         if (typeof (value) == 'object') {
            //             toast.error(value[0], {
            //                 position: "top-center",
            //                 autoClose: 5000,
            //             })
            //         } else {
            //             toast.error(value, {
            //                 position: "top-center",
            //                 autoClose: 5000,
            //             })
            //         }
            //     });
            // }
        }
    }

    const requestDeleteConfirm = (id) => {
        confirmAlert({
          title: 'آیا از حذف درخواست مطمئن هستید؟',
          message: '',
          buttons: [
            {
              label: 'حذف',
              onClick: () => requestDeleteHandler(id)
            },
            {
              label: 'لغو',
            }
          ]
        })
      };
    
    const requestDeleteHandler = async (id) => {

        const data = {
            request_id: id,
        }

      

      
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}exhibition/request/delete`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
        
            if (response.data.status == true) {
                toast.success(response.data.message, {
                    position: "top-center",
                    autoClose: 1200,
                })
                getUserList();
            }
        
        } catch (error) {
            toast.error("حذف درخواست ناموفق بود.", {
                position: "top-center",
                autoClose: 1200,
            })
        }


    }

    const documentStatusUpdateHandler = async (id) => {

        const data = {
            id: id,
        }

        setRahpardaznetId(id);

        setRahpardaznetMessage(' ');
        setRahpardaznetRequestID(id);


        let r = (Math.random() + 1).toString(36).substring(7);
        $("#image-file").fileinput({
            theme: 'fa',
            uploadUrl: `${host}exhibition/request/upload-image`,
            uploadExtraData: function () {
                return {
                    'code': r,
                    'request_id': id,
                };
            },
            allowedFileExtensions: ['jpg', 'png', 'gif', 'jpeg', 'pdf'],
            overwriteInitial: false,
            maxFileSize: 100000,
            maxFilesNum: 10
        });

        setRahpardaznetRandomString(r);

        getDocumentDetails(id);

        $('.fileinput-remove-button').trigger('click');
        $('.modalDocuments').trigger('click');

        return;
        // try {
        //     const response = await axios({
        //         method: 'POST',
        //         url: `${host}document/status/update`,
        //         data: data,
        //         headers: {
        //             'Accept': 'application/json',
        //             'Authorization': `Bearer ${localStorage.getItem('token')}`,
        //             'xsrfHeaderName': "X-XSRF-TOKEN",
        //             'withCredentials': true,
        //         }
        //     })
        //
        //     if (response.data.status == true) {
        //         toast.success(response.data.message, {
        //             position: "top-center",
        //             autoClose: 1200,
        //         })
        //         getUserList();
        //     }
        //
        // } catch (error) {
        //     toast.error("ویرایش نا موفق بود.", {
        //         position: "top-center",
        //         autoClose: 1200,
        //     })
        // }


        // getUserList();
    }
    // $('#image-file').on('fileuploaded', function (event, data) {
    //     getDocumentDetails(RahpardaznetId);
    // });

 

    useEffect(() => {
        if (loading === false && status === true && message != "") {
            toast.success(message, {
                position: "top-center",
                autoClose: 600,
            })
            setStatus(false)
            // message = ''
        }
    }, [status, loading])

    useEffect(() => {
        dispatch(ExhibitionList(token))
    }, [])

    const [users, setUsers] = useState({});
    const [page, setPage] = useState(1);
    const countPerPage = 20;

    const getUserList = async (search = pinCode, pageNumber = page) => {
        $('.dlUCce').addClass('loading');
        search = search == null ? "" : search;
        try {
            const response = await axios({
                method: 'GET',
                url: `${host}exhibitions/requests?page=${pageNumber}&per_page=${countPerPage}&search=${search}&exhibition=${RahpardaznetFilterExhibitionName}&start_date=${start_date}&end_date=${end_date}&delay=1`,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            var userList = JSON.stringify(response.data);
            setUsers(response.data);
            $('.dlUCce').removeClass('loading');

        } catch (error) {
            setUsers({});
            $('.dlUCce').removeClass('loading');
        }
    };



    const getDocumentDetails = async (request_id) => {

        console.log(request_id);
        try {
            const data = {
                'request_id': request_id,
            }
            const response = await axios({
                method: 'post',
                url: `${host}exhibition/request/details`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            setRahpardaznetDetailsData(response.data.data);
            setRahpardaznetDetailsFiles(response.data.files);

        } catch (error) {
            toast.error("خطایی پیش آمد مجددا تلاش نمایید.", {
                position: "top-center",
                autoClose: 1200,
            })
        }
    };


    function searchByDataTable(event) {
        let delayTimeOutFunction;
        delayTimeOutFunction = setTimeout(() => {
            getUserList(event.target.value);


        }, 3000); // denounce delay

        return () => clearTimeout(delayTimeOutFunction);

    };


    const validationCodeHandler = async (e) => {
        e.preventDefault();
        setBtnSms('1');
        const data = {
            mobile: RahpardaznetMobile,
            code: RahpardaznetCode,
            hash: RahpardaznetHash
        }


        try {
            const res = await axios({
                method: 'POST',
                url: `${host}customer/mobile/validationCode`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            if (res.data.status) {
                toast.success("اعتبار سنجی با موفقیت انجام شد.", {
                    position: "top-center",
                    autoClose: 1200,
                })
                setBtnSms('2');
                $('.close').trigger('click');


                setRahpardaznetMessage(' ');
                setRahpardaznetRequestID(RahpardaznetId);
                setRahpardaznetStatusID(RahpardaznetStatus);


                let r = (Math.random() + 1).toString(36).substring(7);
                $("#image-file").fileinput({
                    theme: 'fa',
                    uploadUrl: `${host}exhibition/request/upload-image`,
                    uploadExtraData: function () {
                        return {
                            'code': r,
                            'request_id': RahpardaznetId,
                        };
                    },
                    allowedFileExtensions: ['jpg', 'png', 'gif', 'jpeg', 'pdf'],
                    overwriteInitial: false,
                    maxFileSize: 2048,
                    maxFilesNum: 10
                });
                setRahpardaznetRandomString(r);

                getDocumentDetails(RahpardaznetId);

                $('.fileinput-remove-button').trigger('click');
                $('.modalDocuments').trigger('click');



            } else {
                toast.error("کد تایید نامعتبر است.", {
                    position: "top-center",
                    autoClose: 1200,
                })

                setBtnSms(' ');
            }

        } catch (error) {
            toast.error("کد تایید نا معتبر است.", {
                position: "top-center",
                autoClose: 1200,
            })

            setBtnSms(' ');
        }


        // dispatch(mobileVerificationCode(data))
        // console.log(sms_status);

    }


    const VerificationCodeHandler = async (e) => {
        e.preventDefault();
        setBtnSms('1');
        const data = {
            mobile: RahpardaznetMobile ? RahpardaznetMobile : null
        }


        setRahpardaznetHash(" ");

        try {
            const res = await axios({
                method: 'POST',
                url: `${host}customer/mobile/verificationCode`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            if (res.status == 200) {
                toast.success("پیامک با موفقیت ارسال شد.", {
                    position: "top-center",
                    autoClose: 1200,
                })


                setBtnSms(' ');
                setRahpardaznetHash(res.data.hash);
                setRahpardaznetValidationStatus('1');
            } else {
                toast.error("پیامک ارسال نشد.", {
                    position: "top-center",
                    autoClose: 1200,
                })

                setBtnSms(' ');
            }

        } catch (error) {
            toast.error("پیامک ارسال نشد.", {
                position: "top-center",
                autoClose: 1200,
            })

            setBtnSms(' ');
        }
        // dispatch(mobileVerificationCode(data))
        // console.log(sms_status);

    }

    const [dateObject, setDateObject] = useState(
        new DateObject()
    );

    const convert_end = (date, format = 'YYYY-MM-DD') => {
        let object = { date, format }
        setEnd_date(new DateObject(object).convert(gregorian, gregorian_en).format())
    }
    const convert_start = (date, format = 'YYYY-MM-DD') => {
        let object = { date, format }

        setStart_date(new DateObject(object).convert(gregorian, gregorian_en).format(format))

    }
    const convert_fake = (date, format = 'YYYY-MM-DD') => {
        let object = { date, format }

        setFake_date(new DateObject(object).convert(gregorian, gregorian_en).format(format))

    }



    const [pinCode, setPinCode] = useState("");
    useEffect(() => {
        getUserList()
    }, []);

    const rahkarpardaznet_search_datatable = (e) => {
        e.preventDefault();
        setPage(1);

        $('#pagination-first-page').trigger('click');
        getUserList(pinCode, 1);
    }
    const handlePageChange = (page) => {
        setPage(page);
        getUserList('', page);
    };
    const RahpardaznetSubmitChangeStatus = async (e) => {
        e.preventDefault()
        const data = {
            'id': RahpardaznetId,
            'status': RahpardaznetStatus,
            'hash_code': RahpardaznetRandomString,
            'fake_date': fake_date,
            'fake_date_fa': moment(fake_date).locale('fa').format('YYYY/MM/DD HH:mm:ss')
        }

        try {
            const response = await axios({
                method: 'POST',
                url: `${host}document/status/update`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })

            if (response.data.status == true) {
                toast.success(response.data.message, {
                    position: "top-center",
                    autoClose: 1200,
                })
                setRahpardaznetMessage(' ');
                $('.fileinput-remove-button').trigger('click');
                $('.modalDocuments').trigger('click');
                getUserList();
            }

        } catch (error) {
            toast.error("ویرایش نا موفق بود.", {
                position: "top-center",
                autoClose: 1200,
            })
        }
    };


    useEffect(() => {








    }, [])
    const RahpardaznetSubmitMessage = async (e) => {
        e.preventDefault()
        if (RahpardaznetMessage == null || RahpardaznetMessage == " ") {
            toast.error("یادداشت خالی می باشد.", {
                position: "top-center",
                autoClose: 1200,
            })
            return;
        }
        // alert(RahpardaznetMessage);
        const data = {
            'message': RahpardaznetMessage,
            'request_id': RahpardaznetRequestID,
        }
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}exhibition/request/message`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })

            if (response.data.status == true) {
                toast.success('یادداشت با موفقیت ایجاد شد.', {
                    position: "top-center",
                    autoClose: 1200,
                })
                getDocumentDetails(RahpardaznetRequestID);
                $(".rahpardaznet-list-message").animate({
                    scrollTop: $('.rahpardaznet-list-message').get(0).scrollHeight
                }, 1500);
                setRahpardaznetMessage(' ');

            }

        } catch (error) {
            toast.error("یادداشت اضافه نشد.", {
                position: "top-center",
                autoClose: 1200,
            })
        }
    };

    return (
        <>


            <button type="button" className="d-none modalDocuments" data-toggle="modal" data-backdrop="static"
                data-keyboard="false" data-target="#modalDocuments"></button>

            <div className="modal modal-xl  fade" id="modalDocuments">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">جزئیات سند</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div className="modal-body">
                            <div className="row">
                                <div className='col-12 rahpardaznet-request-list-file'>
                                    {
                                        (typeof RahpardaznetDetailsFiles == 'object' && RahpardaznetDetailsFiles.length > 0) ? (
                                            <>
                                                {
                                                    RahpardaznetDetailsFiles.map((file, key) => (
                                                        <div className="rahpardaznet-request-file">
                                                            <div>{moment(file.created_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}</div>
                                                            <div>{file.title ? file.title : 'بدون عنوان'}</div>
                                                            <div>
                                                                <a href={"http://185.36.231.91/~rahpardaz/backend.rahpardaz.net/" + file.url} target='_blank'>دانلود فایل</a>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </>
                                        ) : (
                                            <div>پیوستی جهت نمایش وجود ندارد.</div>
                                        )
                                    }
                                </div>
                                <div className="col-12 col-md-7 input-100">
                                    <div>
                                        <div className="form-group rahpardaznet-small-file">
                                            <div className="file-loading">
                                                <input id="image-file"
                                                    type="file" name="file"
                                                    accept="image/*"
                                                    data-min-file-count="1"
                                                    multiple />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-5">
                                    <div className="container">
                                        <div className="rahpardaznet-list-message">

                                            {
                                                (typeof RahpardaznetDetailsData == 'object' && RahpardaznetDetailsData.length > 0) ? (
                                                    <>
                                                        {
                                                            RahpardaznetDetailsData.map((note, key) => (
                                                                <div className="message-candidate center-block">
                                                                    <div className="row rahpardaznet-message-details">
                                                                        <div className="col-xs-8 col-md-6 p-0">
                                                                            <h6 className="message-name"> {note.user_id}</h6>
                                                                        </div>
                                                                        <div className="col-xs-4 col-md-6 p-0 text-left message-date">
                                                                            {moment(note.created_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}
                                                                        </div>
                                                                    </div>
                                                                    <div className="row message-text">
                                                                        {note.description}
                                                                    </div>
                                                                </div>
                                                            ))
                                                        }
                                                    </>
                                                ) : (
                                                    <div>یادداشتی جهت نمایش وجود ندارد.</div>
                                                )
                                            }


                                        </div>
                                        <div className="messaging center-block">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <form onSubmit={RahpardaznetSubmitMessage}>
                                                        <div className="input-group">
                                                            <input type="text" className="rahpardaznet-form-message"
                                                                value={RahpardaznetMessage}
                                                                onChange={(e) => setRahpardaznetMessage(e.target.value)}
                                                                placeholder="توضیحات را وارد نمایید." />

                                                            <button className="rahpardaznet-button-send-message"
                                                                type="submit">ثبت
                                                            </button>

                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-12 border-top mt-3 pt-3 text-left">
                                    <button className="rahpardaznet-button" onClick={RahpardaznetSubmitChangeStatus}  type="button">
                                        ذخیره تغیرات
                                    </button>
                                </div> */}
                            </div>


                        </div>
                    </div>
                </div>
            </div>
            <button type="button" className="d-none modalOwnerMobile" data-toggle="modal" data-backdrop="static"
                data-keyboard="false" data-target="#modalOwnerMobile"></button>

            <div className="modal fade" id="modalOwnerMobile">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">اعتبار سنجی شماره موبایل مالک</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <input type="hidden" value={RahpardaznetHash ? RahpardaznetHash : null}
                            onChange={(e) => setRahpardaznetHash(e.target.value)} />
                        <div className="modal-body">
                            {(RahpardaznetValidationStatus == '1') ? (
                                <>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"
                                                id="inputGroup-sizing-default">کد تایید</span>
                                        </div>
                                        <input type="text" className="form-control rahpardaznet-mobile-border"
                                            aria-label="Default" aria-describedby="inputGroup-sizing-default"
                                            value={RahpardaznetCode ? RahpardaznetCode : null}
                                            onChange={(e) => setRahpardaznetCode(e.target.value)} />
                                    </div>
                                    <div className='rahpardaznet-modal-footer'>
                                        <button type="submit" onClick={validationCodeHandler}> {BtnSms == '1' ? (
                                            <div className="spinner-border text-light"
                                                role="status"></div>) : "اعتبارسنجی"}</button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"
                                                id="inputGroup-sizing-default">شماره موبایل</span>
                                        </div>
                                        <input type="text" className="form-control rahpardaznet-mobile-border"
                                            aria-label="Default" aria-describedby="inputGroup-sizing-default"
                                            value={RahpardaznetMobile ? RahpardaznetMobile : null}
                                            onChange={(e) => setًRahpardaznetMobile(e.target.value)} />
                                    </div>
                                    <div className='rahpardaznet-modal-footer'>
                                        <button onClick={VerificationCodeHandler}>{BtnSms == '1' ? (
                                            <div className="spinner-border text-light"
                                                role="status"></div>) : "ارسال کد"}</button>
                                    </div>
                                </>
                            )}


                        </div>
                    </div>
                </div>
            </div>
            {(loading || RahpardaznetLoading == '1') ? <Loading /> : ''}

            <Broadcast title={'درخواست های نمایشگاه ها'} />
            <div className='row rahpardaznet-cart  my-5  print-position'>
                <Header title='خروجی اکسل' />
                <div className='row'>
                    <div className='col-12 d-flex'>
                        <div className='rahpardaznet-excel-form d-grid'>
                            <label>نمایشگاه</label>
                            <select
                                value={RahpardaznetFilterExhibitionName ? RahpardaznetFilterExhibitionName : '0'}
                                onChange={(e) => setRahpardaznetFilterExhibitionName(e.target.value)}
                            >
                                <option value="0">همه نمایشگاه ها</option>
                                {
                                    (typeof exhibitions == 'object' && exhibitions.length > 0) ? (

                                        exhibitions.map((row, key) => (
                                            <option value={row.id}>{row.name}</option>
                                        ))
                                    ) : null
                                }
                            </select>
                        </div>
                        <div className='rahpardaznet-excel-form d-grid'>
                            <label>از تاریخ</label>
                            <DatePicker
                                tabIndex="1"
                                calendar={persian}
                                locale={persian_fa}
                                calendarPosition="bottom-right"
                                value={start_date.date ? start_date.date : null}
                                onChange={convert_start}
                            />
                        </div>
                        <div className='rahpardaznet-excel-form d-grid'>
                            <label>تا تاریخ</label>
                            <DatePicker
                                tabIndex="2"
                                calendar={persian}
                                locale={persian_fa}
                                calendarPosition="bottom-right"
                                value={end_date.date ? end_date.date : null}
                                onChange={convert_end}
                            />
                        </div>
                        <div className='rahpardaznet-excel-form'>
                            <button type="button" className='rahpardaznet-btn-inline'
                                onClick={rahpardaznetFilterRequest}>جستجو
                            </button>
                        </div>
                        <div className='rahpardaznet-excel-form'>
                            <button type="button" className='rahpardaznet-btn-inline'
                                onClick={rahpardaznetExportExcel}>خروجی اکسل
                            </button>
                        </div>
                        <div className='rahpardaznet-excel-form'>
                            <button className='rahpardaznet-btn-outline' onClick={rahpardazneRestForm}>پاکسازی</button>
                        </div>


                    </div>
                </div>

            </div>
            <div className='row g-2 pr-3 pl-3 pb-4'>

                <div className="App">
                    <form onSubmit={rahkarpardaznet_search_datatable} className="rk-search-bar">
                        <input type="text" id="" placeholder='جستجو کنید'
                            value={pinCode}
                            onChange={(event) => setPinCode(event.target.value)} />
                        <button type="submit"><Icon.Search /></button>

                    </form>
                    <DataTable
                        title=""
                        columns={columns}
                        data={users.data}
                        highlightOnHover
                        pagination
                        paginationServer
                        paginationTotalRows={users.total}
                        paginationPerPage={countPerPage}
                        paginationComponentOptions={{
                            noRowsPerPage: true
                        }}
                        expandableRows
                        expandableRowExpanded={row => row.defaultExpanded}
                        expandableRowsComponent={ExpandedComponent}
                        onChangePage={handlePageChange}
                    />
                </div>


            </div>

        </>
    )
}

export default RequestExhibitions;